import { Typography } from "@mui/material";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { TitleContainer, Wrapper } from "../../style";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import "./RedirectPageStyle.less";
import { DashboardButton } from "../../../common/DashboardButton";
import { FormattedMessage } from "react-intl";

const ErrorPage = () => {
  return (
    <Wrapper className="redirect-page">
      <ColumnContainer align="center" style={{ height: "100vh" }}>
        <ColumnContainer align="center">
          <SentimentDissatisfiedIcon
            fontSize="large"
            sx={{ color: "var(--main-color)" }}
          />
          <RowContainer align="center" center>
            <TitleContainer>
              <Typography variant="h4" component="h4">
                <FormattedMessage id="order.error" />
              </Typography>
            </TitleContainer>
          </RowContainer>
          <RowContainer align="center" center>
            <Typography variant="h6" component="h6">
              <FormattedMessage id="order.error.paypal" />.
            </Typography>
          </RowContainer>
          <RowContainer align="center" center>
            <DashboardButton type="outlined">
              {" "}
              <FormattedMessage id="button.contactUs" />
            </DashboardButton>
            >
          </RowContainer>
        </ColumnContainer>
      </ColumnContainer>
    </Wrapper>
  );
};
export default ErrorPage;
